/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Modal } from "react-bootstrap";
// import { useHistory } from "react-router-dom";
import { emailBlueIcon, emailWhiteIcon, IMSLogo } from "../../assets";
import React, { useEffect, useState } from "react";
import Button from "../Button";
import DisclaimerPop from "../PopUp/DisclaimerPop";
import GenAIGSFSaveSubModal from "./GenAIGSFSaveSubModal";

import DocumentProcessing from '../PopUp/DocumentProcessing'
import EmailProcessingPopUpModal from "../PopUp/EmailProcessing";
import DownloadProcessingPopUpModal from "../PopUp/DownloadProcessing";
import './GenAIGlobalSearchFeaturesPopUpModal.css'
// import jsPDF from "jspdf";
// import * as html2canvas from "html2canvas";
import * as FileSaver from 'file-saver';
import GenerateArrayStrings, { getVarType } from "../GenerateArrayStrings"
import ReactDOMServer from "react-dom/server"
import HtmlView from "../../content/Pages/HtmlView";
import GenAIHtmlView from "../../content/Pages/GenAIHtmlView";
import MobileViewButton from "../Button/MobileViewButton";
import { v4 as uuidv4 } from 'uuid';
import ApiServices from '../../utils/apiServices';
import axios from "axios";
import trackingService from "../../services/trackingService";
import { useReactToPrint } from "react-to-print";
import { LocationOrigin } from "../../utils/utilityServices";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import moment from 'moment';
import { Authentication } from "../../utils/authenticationUtilityServices";
import PDFCitationdetailsGenAI from "../../content/DownloadGenAI/PDFCitationdetailsGenAI";

// const chunkSize = 1048576 * 3;//its 3MB, increase the number measure in mb
const chunkSize = 50000;//its 3MB, increase the number measure in mb
// const chunkSize = 5
export default function GenAIGlobalSearchFeaturesPopUpModal(props) {
    const {
        height,
        showModal,
        handleClose,
        selectedResults,
        customWidth,
        documentsUrl,
        markedDocumentsUrl,
        itemsPerPage
    } = props
    // let history = useHistory();
    const [showPop, setShow] = useState(showModal)
    const [showDisclaimer, setDisclaimer] = useState(false);
    //To create the pdf html file 
    // const [pdfHtml, setPdf] = useState(false)
    // const [showPrintPopUp, setShowPrintPopUp] = useState(false)
    const [isSaveModal, setIsSaveModal] = useState();
    const [isPrintModal, setIsPrintModal] = useState();
    const [isEmailModal, setIsEmailModal] = useState();
    const [isDownloadModal, setDownloadModal] = useState();
    const [saveResult, setSaveResult] = useState('Marked Results');
    const [saveFields, seSavetFields] = useState('Full Citation');
    const [saveFormat, setSaveFormat] = useState('Excel');
    const [printResult, setPrintResult] = useState('Marked Results');
    const [printFields, setPrintFields] = useState('Title Only');
    const [emailResult, setEmailResult] = useState('Marked Results');
    const [emailFields, setEmailFields] = useState('Title Only');
    const [downloadResult, setDownloadResult] = useState('Marked Results');
    const [showSaveToExcel, setSaveToExcel] = useState(false);
    const [docProcessing, setDocProcessing] = useState(false);
    const [emailProcessing, setEmailProcessing] = useState(false);
    const [isDownloadProceed, setIsDownloadProceed] = useState(false);
    const [downloadData, setDownloadData] = useState([]);
    const [downloadZipProcessing, setDownloadZipProcessing] = useState(false);
    const [uniqueId, setUniqueId] = useState(0);
    const [isPrintProceed, setIsPrintProceed] = useState(false);
    const componentRef = React.useRef(null);
    // var uniqueId = Math.floor(100000 + Math.random() * 900000);

    // const [showProgress, setShowProgress] = useState(false)
    // let [counter, setCounter] = useState(1)
    const [fileToBeUpload, setFileToBeUpload] = useState({})
    let [beginingOfTheChunk, setBeginingOfTheChunk] = useState(0)
    let [endOfTheChunk, setEndOfTheChunk] = useState(chunkSize)
    // const [progress, setProgress] = useState(0)
    // const [fileGuid, setFileGuid] = useState("")
    const [fileSize, setFileSize] = useState(0)
    const [chunkCount, setChunkCount] = useState(0)
    const [alertMessageModelColor, setAlertMessageModelColor] = useState("")
    const [alertMessageContent, setAlertMessageContent] = useState("")
    const [alertMessageShowModal, setAlertMessageShowModal] = useState(false)
    const errorAlertMessage = (message) => {
        setAlertMessageContent(message)
        setAlertMessageModelColor("#de1327")
        setAlertMessageShowModal(true)
    }
    const closeAlertMessage = () => {
        setAlertMessageContent("")
        setAlertMessageModelColor("")
        setAlertMessageShowModal(false)
    }

    // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // const fileExtension = '.xlsx';
    let counter = 1;
    useEffect(() => {
        if (fileSize > 0) {
            fileUpload(counter);
        }
    }, [fileToBeUpload])
    async function getFileContext(wwid, username, html, currentDate, searchId) {
        resetChunkProperties();
        setFileSize(html.length)
        const _totalCount = html.length % chunkSize === 0 ? html.length / chunkSize : Math.floor(html.length / chunkSize) + 1;
        setChunkCount(_totalCount)
        setFileToBeUpload(html)
    };
    const resetChunkProperties = () => {
        // setShowProgress(true)
        // setProgress(0)
        // setCounter(1)
        setBeginingOfTheChunk(0)
        setEndOfTheChunk(chunkSize)
    }
    const fileUpload = async () => {
        var guid = uuidv4();
        let currentDate = generateDownloadTimestamp()
        let wwid = JSON.parse(localStorage.getItem('wwid'))
        let username = JSON.parse(localStorage.getItem('username'));
        let searchId = `${guid}_${currentDate}`
        setEmailProcessing(true);
        let service = new ApiServices();
        await service.createShareEmail(
            wwid,
            username, currentDate, searchId, fileToBeUpload
        ).then(async (response) => {
            const data = response.data;
            if (data.rowCount === 1) {
                handleEmail(searchId)
            }
        }).catch((error) => {
            console.log(error);
        }).finally(() => {
            setEmailProcessing(false);
        });
    }
   
    //     const uploadChunk = async (chunk) => {
    //         // wwid, username, html.replace(/"/g, '\\"'), currentDate, currentDate, searchId
    //         let titleOnlyEmail = false
    //         if (emailFields === 'Title Only') {
    //             titleOnlyEmail = true
    //         }
    //         const html = ReactDOMServer.renderToString(<HtmlView selectedResults={selectedResults} titleOnly={titleOnlyEmail} citationType={emailResult} />);
    //         var guid = uuidv4();
    //         let currentDate = generateDownloadTimestamp()
    //         let wwid = JSON.parse(localStorage.getItem('wwid'))
    //         let username = JSON.parse(localStorage.getItem('username'));
    //         let searchId = `${guid}_${currentDate}`
    //         let payload = {
    //             "wwid": wwid,
    //             "username": username,
    //             "htmldocument": html.replace(/"/g, '\\"'),
    //             "date_added": currentDate,
    //             "date_modified": currentDate,
    //             "search_id": searchId,
    //         }
    //         try {
    //             const response = await axios.post(
    //                 "https://predev-ims.jnj.com/api/db/emlst",
    //                 chunk,
    //                 {
    //                     // params: payload,
    //                     //   params: {

    //                     //     // id: counter,
    //                     //     // fileName: fileGuid,
    //                     //   },
    //                     headers: { "Content-Type": "application/json" },
    //                 }
    //             );
    //             const data = response.data;
    //             // console.log("data", data)
    //             //   if (data.isSuccess) {
    //             if (data.rowCount == 1) {
    // // console.log(counter)


    //                 // setBeginingOfTheChunk(endOfTheChunk);
    //                 // setEndOfTheChunk(endOfTheChunk + chunkSize);
    //                 // console.log(endOfTheChunk, endOfTheChunk + chunkSize,)
    //                 // counter++
    //                 // if (counter == chunkCount) {
    //                     if (counter <= chunkCount) {

    //                     console.log("Process is complete, counter", counter);
    //                     return response
    //                     // count++
    //                     // counter++
    //                     //   await uploadCompleted(chunk);
    //                     // chunk.append(...chunk)
    //                     // append(...data)
    //                 } /* else {
    //               var percentage = (counter / chunkCount) * 100;
    //             //   setProgress(percentage);
    //             } */
    //             } else {
    //                 console.log("Error Occurred:", data);
    //             }
    //         } catch (error) {
    //             console.log("error", error);
    //         }
    //     };

    useEffect(() => {
        if (selectedResults.length > 0) {
            setSaveResult('Marked Results');
            setEmailResult('Marked Results');
            setDownloadResult('Marked Results');
            setPrintResult('Marked Results')
        }
        else {
            setSaveResult('Displayed Results');
            setEmailResult('Displayed Results');
            setDownloadResult('Displayed Results');
            setPrintResult('Displayed Results')
        }
    }, [selectedResults])
    const generateDownloadTimestamp = () => {
        const now = new Date()
        return now.getFullYear() + "-" + (now.getMonth() + 1) + "-" + now.getDate() + "_" + now.getHours() + "-" + now.getMinutes() + "-" + now.getSeconds()
    }
    const downloadTxtFile = () => {
        const element = document.createElement("a");
        const file = new Blob([document.getElementById('pdf-doc-to-print').value], { type: 'text/plain;charset=utf-8' });
        element.href = URL.createObjectURL(file);
        let txtfileName = "iMS_Results_Download_" + generateDownloadTimestamp() + ".txt"
        element.download = txtfileName;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
    }
    // const MyDocument = () => {
    //     return (
    //         <a href="">Link</a>
    //         // <div><a href="">Link</a></div>
    //         // <Document>
    //         //     <Page size="A4" style={styles.page}>
    //         //         <View>
    //         //             <div className="bannerImage">
    //         //                 <div className="headerTitle" style={{ alignItems: "center", textAlign: "center" }}>
    //         //                     <img src={IMSLogo} alt="iMedical Search" style={{ width: "20%", paddingTop: "2%" }} />
    //         //                 </div>
    //         //             </div>
    //         //         </View>
    //         //     </Page>
    //         // </Document>
    //     );
    // }
    // const savePDF = () => {
    //     setDocProcessing(true);
    //     const fileName = "iMS_Results_Download_" + generateDownloadTimestamp() + ".pdf"
    //     const doc = new jsPDF('p', 'mm');
    //     // let titleOnly = false
    //     // if (saveFields === 'Title Only') {
    //     //     titleOnly = true
    //     // }
    //     // doc = ReactDOMServer.renderToString(<HtmlView selectedResults={selectedResults} titleOnly={titleOnlyEmail} citationType={emailResult} />);
    //     const elem = document.getElementById('pdf-doc-to-print')
    //     html2canvas(elem, {
    //         onclone: function (clonedDoc) {
    //             clonedDoc.getElementById('pdf-doc-to-print').style.display = 'block';
    //         }
    //     }).then((canvas) => {
    //         const data = canvas.toDataURL('image/png');
    //         var position = 0;
    //         var imgWidth = 210;
    //         var pageHeight = 295;
    //         var imgHeight = canvas.height * imgWidth / canvas.width;
    //         var heightLeft = imgHeight;
    //         doc.addImage(data, 'PNG', 0, position, imgWidth, imgHeight);
    //         heightLeft -= pageHeight;
    //         //doc.add
    //         while (heightLeft >= 0) {
    //             position = heightLeft - imgHeight;
    //             doc.addPage();
    //             doc.addImage(data, 'PNG', 0, position, imgWidth, imgHeight);
    //             heightLeft -= pageHeight;
    //         }
    //         // doc.html(ReactDOMServer.renderToString(<HtmlView selectedResults={selectedResults} titleOnly={titleOnly} citationType={saveResult} />), {
    //         //     callback: function (doc) {
    //         //          doc.save(fileName);
    //         //       }
    //         //   });
    //         doc.save(fileName)
    //         setDocProcessing(false)
    //     })
    // }
    useEffect(() => {
        if (props.showSaveModal) {
            setIsSaveModal(props.showSaveModal)
            // setIsEmailModal(false)
            // setIsPrintModal(false)
            // setDownloadModal(false)
        }
        // else{
        //     setIsSaveModal(false)
        // }
        else if (props.showPrintModal) {
            setIsPrintModal(props.showPrintModal)
            // setIsSaveModal(false)
            // setIsEmailModal(false)
            // setDownloadModal(false)
        }
        else if (props.showEmailModal) {
            setIsEmailModal(props.showEmailModal)
            // setIsSaveModal(false)
            // setIsPrintModal(false)
            // setDownloadModal(false)
        }
        else if (props.showDownloadModal) {
            setDownloadModal(props.showDownloadModal)
            // setIsSaveModal(false)
            // setIsPrintModal(false)
            // setIsEmailModal(false)
        }
        if (selectedResults.length <= 0) {
            //console.log('No Selected Results')
            setSaveResult('Displayed Results')
        }
        //console.log(props.showSaveModal, props.showPrintModal, props.showEmailModal, props.showDownloadModal,selectedResults)
    }, [])
    useEffect(() => {
        if (isSaveModal && saveFormat === 'Excel') {
            seSavetFields('Full Citation')
        }
    }, [saveFormat])
    useEffect(() => {
        setIsPrintProceed(true)
    }, [isPrintProceed])
    const onSaveClick = () => {
        setIsSaveModal(true);
        setIsPrintModal(false);
        setIsEmailModal(false);
        setDownloadModal(false);
        setIsDownloadProceed(false);
    }
    // const onPrintClick = () => {
    //     setIsSaveModal(false);
    //     setIsPrintModal(true);
    //     setIsEmailModal(false);
    //     setDownloadModal(false);
    //     setIsDownloadProceed(false);
    // }
    const onEmailClick = () => {
        setIsSaveModal(false);
        setIsPrintModal(false);
        setIsEmailModal(true);
        setDownloadModal(false);
        setIsDownloadProceed(false);
    }
    const onDownloadClick = () => {
        setIsSaveModal(false);
        setIsPrintModal(false);
        setIsEmailModal(false);
        setDownloadModal(true);
    }
    const handleOnChangeSaveResult = (event) => {
        setSaveResult(event.target.value)
    }
    const handleOnChangeSaveFieldstoInclude = (event) => {
        seSavetFields(event.target.value)
    }
    const handleOnChangeSaveFormat = (event) => {
        setSaveFormat(event.target.value)
    }
    const handleOnChangePrintResult = (event) => {
        setPrintResult(event.target.value)
        setIsPrintProceed(false)
    }
    const handleOnChangePrintFieldstoInclude = (event) => {
        setPrintFields(event.target.value)
    }
    const handleOnChangeEmailResult = (event) => {
        setEmailResult(event.target.value)
    }
    const handleOnChangeEmailFieldstoInclude = (event) => {
        setEmailFields(event.target.value)
    }
    const handleOnChangeDownloadResult = (event) => {
        setDownloadResult(event.target.value)
    }
    const onClickProceed = async () => {
        let width = 0.80 * window.innerWidth
        let height = 0.85 * window.innerHeight
        let left = 0.10 * window.innerWidth
        let top = 0.10 * window.innerHeight
        let titleOnly = false
        let titleOnlyEmail = false
        let displayResults = JSON.parse(localStorage.getItem('displayedResults'))
        if (saveFields === 'Title Only') {
            titleOnly = true
        }
        if (emailFields === 'Title Only') {
            titleOnlyEmail = true
        }
        if (isSaveModal) {
            if (saveFormat === "Excel") {
                if ((selectedResults && selectedResults.length > 0) || displayResults) {
                    if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
                        setSaveToExcel(true);
                    } else {
                        await onClickDownloadExcel();
                    }
                }
                else {
                    errorAlertMessage("No content to save as excel");
                }
            }
            else if (saveFormat === "Pdf") {
                if ((selectedResults && selectedResults.length > 0) || displayResults) {
                    setDocProcessing(true);
                    const fileName = (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? "iMS_Results_Download_" + generateDownloadTimestamp() + ".pdf" : "PubMed_iMS_Results_Download_" + generateDownloadTimestamp() + ".pdf"
                    const html = ReactDOMServer.renderToString(<PDFCitationdetailsGenAI selectedResults={selectedResults} citationType={saveResult} titleOnly={titleOnly} customWidth={customWidth} />);
                    {/*const newTb = window.open();
                    let css = UtilityServices.getPdfCSSGenAI();
                            let doc = `<!DOCTYPE html><html><head><meta charset='UTF-8'><meta name='viewport' content='width=device-width, initial-scale=1.0'>
                            <style>
                            ${css}
                        </style>
                            </head><body><div class='App'>${html.replace(
                                /\\"/g,
                                "'"
                            )} </div></body></html>`;
                    newTb.document.open();
                    newTb.document.writeln(doc)*/}
                    let service = new ApiServices();
                    await service.preparePDFDocumentGenAI(html).then((res) => {
                        const data = new Blob([res.data], { type: 'application/pdf' });
                        FileSaver.saveAs(data, fileName);
                        setDocProcessing(false)
                    }).catch((error) => {
                        console.log(error);
                        setDocProcessing(false)
                    });
                } else {
                    errorAlertMessage("No content to save as pdf");
                }
            }
            else if (saveFormat === "HTML") {
                if ((selectedResults && selectedResults.length > 0) || displayResults) {
                    let newWindow = window.open(window.location.origin + '/GenAIDownload', '_blank', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
                    newWindow.citationType = saveResult;
                    newWindow.selectedResults = selectedResults;
                    newWindow.titleOnly = titleOnly;
                    newWindow.customWidth = customWidth;
                    newWindow.isPubMedHtml = window.location.pathname === '/pubMedResults' || window.location.pathname === '/viewPubMedReadingList';
                }
                else {
                    errorAlertMessage("No content to save as html");
                }
            }
            else {
                downloadTxtFile()
            }
            // if (saveFormat !== "Excel") {
            handelSaveExportDocsTypes(saveFormat)
            // }
        }
        if (isPrintModal) {
            if ((selectedResults && selectedResults.length > 0) || displayResults) {
                handelPrintDocs()
                handlePrint()
            }
            else {
                errorAlertMessage("No content available to Print");
            }
        }
        if (isEmailModal) {
            if ((selectedResults && selectedResults.length > 0) || displayResults) {
                const html = ReactDOMServer.renderToString(<GenAIHtmlView selectedResults={selectedResults} titleOnly={titleOnlyEmail} citationType={emailResult} />);
                // var result = html.replace(/"/g, "'").replace(/>\s+|\s+</g, function(m) {
                //     return m.trim();
                // });

                // console.log(html.replace(/"/g, '\\"'))
                // console.log(html.replace(/"/g, "'").replace(/>\s+</g, "><")) //replace(/"/g, "'")   replace(/"/g, '\'')
                var guid = uuidv4();
                let currentDate = generateDownloadTimestamp()
                // console.log(`${guid}_${currentDate}`)
                let service = new ApiServices();
                let wwid = JSON.parse(localStorage.getItem('wwid'))
                // let wwid = parseInt(localStorage.getItem('wwid').replace(/"/g, ''));
                let username = JSON.parse(localStorage.getItem('username'));
                let searchId = `${guid}_${currentDate}`
                let res = await service.getEmailDocumentById(username);
                let date = [];
                let newdate = [];
                let expiryDate = [];
                // var date = new Date(res[0].date_added.split('_')[0])
                // var newDate = new Date(date.setMonth(date.getMonth() + 1));
                // let expiryDate = new Date(new Date(newDate).setMonth(new Date(newDate).getMonth() + 2))
                // const convertStringToByteArray = (str) => {
                //     String.prototype.encodeHex = function () {
                //         var bytes = [];
                //         for (var i = 0; i < this.length; ++i) {
                //             bytes.push(this.charCodeAt(i));
                //         }
                //         return bytes;
                //     }

                //     var byteArray = str.encodeHex();
                //     // console.log(byteArray)
                //     return byteArray
                // }
                // WORKING START DELETE
                for (let index = 0; index < res.length; index++) {
                    // date = date.concat(dateFormate(new Date(res[index].date_added.split('_')[0])))
                    date = new Date(res[index].date_added.split('_')[0]);
                    newdate = new Date(date.setMonth(date.getMonth() + 1));
                    // expiryDate=new Date(new Date(newdate).setDate(new Date(newdate).getDate() + 2))
                    expiryDate = new Date(new Date(newdate).setMonth(new Date(newdate).getMonth() + 2))
                    if (expiryDate <= new Date()) {
                        await service.deleteEmailDocumentBy(username, res[index].search_id)
                    }
                    // else{
                    //     console.log(expiryDate,new Date())
                    // }
                }
                // WORKING END DELETE
                // WORKING START
                getFileContext(wwid, username, html, currentDate, searchId);
                handelEmailDocsTypes(searchId);
                // WORKING END



                // console.log(res,expiryDate,newdate,expiryDate<=new Date())
                // if(expiryDate>=new Date()){
                //     console.log("hi")
                // await service.deleteEmailDocumentBy(wwid,res[0].search_id)
                //    let resData = await service.deleteEmailDocumentBy(wwid,res[0].search_id)
                //    console.log(resData)
                // }
                // async () => {
                // WORKING
                // let data = await service.insertEmailDocument(wwid, username, html.replace(/"/g, '\\"'), currentDate, currentDate, searchId);
                // console.log(data, "xx")
                // }

                // handleEmail(searchId)
            }
            else {
                errorAlertMessage("No content available to share (Email)");
            }
        }
        if (isDownloadModal) {
            // console.log(documentsUrl)
            let urls;
            if (downloadResult === 'Marked Results') {
                urls = markedDocumentsUrl;
            }
            else {
                urls = documentsUrl;
            }
            if (urls && urls.length > 0 && ((selectedResults && selectedResults.length > 0) || displayResults)) {
                let noOfDocumentPerZip = 10;
                let postBodys = [];
                for (let i = 1; i <= Math.ceil(urls.length / noOfDocumentPerZip); i++) {
                    let url = urls.slice(((i - 1) * noOfDocumentPerZip), (((i - 1) * noOfDocumentPerZip) + noOfDocumentPerZip));
                    postBodys.push(url);
                    // console.log(url, postBodys);
                }
                // uniqueId = Math.floor(100000 + Math.random() * 900000);
                setUniqueId(Math.floor(100000 + Math.random() * 900000))
                setIsDownloadProceed(true)
                setDownloadData(postBodys)
            }
            else {
                errorAlertMessage("No file to download");
            }
        }
    }
    const proceedDownload = (data) => {
        let displayName = JSON.parse(localStorage.getItem("userdisplayName"))?.replace(/\s/g, '');
        //let currentDate = new Date().toString("dMMMyyyy");
        let currentDate = moment().format("DMMMYYYY");
        if (data.length > 0) {
            return (
                <>
                    {
                        data.map((urls, index) => {
                            return (
                                <div className="gen-ai-gsf-popup__content">
                                    <div className="gen-ai-gsf-popup__row gen-ai-gsf-popup__row--spaced">
                                        <div className="gen-ai-gsf-popup__label" style={{ minWidth: "350px" }}>{`${displayName}_${currentDate + uniqueId}_${index + 1}.zip `}</div>
                                        <div className="gen-ai-gsf-popup__value"><span className="gen-ai-gsf-popup__link" onClick={() => downloadZip(index)}>Download</span></div><br />
                                    </div>
                                </div>
                            )
                        })
                    }
                </>
            )
        }
    }
    const downloadZip = async (index) => {
        let res;
        let body = {
            urls: downloadData[index]
        }
        let displayName = JSON.parse(localStorage.getItem("userdisplayName"))?.replace(/\s/g, '');
        //let currentDate = new Date().toString("dMMMyyyy");
        let currentDate = moment().format("DMMMYYYY");
        const fileName = `${displayName}_${currentDate + uniqueId}_${index + 1}.zip`;
        let service = new ApiServices();
        setDownloadZipProcessing(true)
        handelDownloadDocs(fileName)
        await service.downloadZipFile(body)
           /*  await axios.post(
                // `${LocationOrigin}${process.env.REACT_APP_IMS_API_URL}?dbquery=${dbquery}`,
                'http://localhost:8080/download',
                body,
                {
                    responseType: 'blob',
                }
            ) */.then((response) => {
            res = response.data
            if (res) {
                setDownloadZipProcessing(false)
            }
            const data = new Blob([res], { type: 'application/zip' });
            FileSaver.saveAs(data, fileName);
            //this.logService(`API call successful for dbquery:${dbquery}`,'info')
        }).catch((error) => {
            console.log(error)
            setDownloadZipProcessing(false)
            // this.logService(`API call failed for dbquery:${dbquery}`,'error')
        })
    }
    const downloadAll = async () => {
        let userId = localStorage.getItem('username')?.toLowerCase()?.replace(/"/g, '').split('@')[0]
        let newWindow = window.open(window.location.origin + `/docs?UserId=${userId}`, '_blank');
        newWindow.citationType = downloadResult;
        newWindow.selectedResults = markedDocumentsUrl;
        newWindow.displayResults = documentsUrl;
        handelDownloadAllDocs()
        for (let index = 0; index < downloadData.length; index++) {
            await downloadZip(index);
        }
    }
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,//reactToPrintContent,
        documentTitle: (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? `iMS_Documents_${generateDownloadTimestamp()}` : "PubMed Search Results " + generateDownloadTimestamp(),
        // onBeforeGetContent: handleOnBeforeGetContent,
        // onBeforePrint: handleBeforePrint,
        // onAfterPrint: handleAfterPrint,
        removeAfterPrint: true
    });
    let titleOnlyPrint = false
    if (printFields === 'Title Only') {
        titleOnlyPrint = true
    }
    const onViewClick = () => {
        let titleOnly = false
        if (saveFields === 'Title Only') {
            titleOnly = true
        }
        localStorage.setItem('ExcelViewSaveResult', JSON.stringify(saveResult));
        localStorage.setItem('ExcelViewSelectedResults', JSON.stringify(selectedResults));
        let newWindow = window.open(window.location.origin + '/Excel-View', '_blank')
        newWindow.citationType = saveResult;
        newWindow.selectedResults = selectedResults;
        newWindow.titleOnly = titleOnly;
        // handelSaveExportDocsTypes(saveFormat)
    }
    const onClickDownloadExcel = async () => {
        let csvData = [];
        let results;
        let columns = [];
        let fileName = `iMS_Results_Download_${generateDownloadTimestamp()}.xlsx`;
        let worksheetName = "iMS_Results_Excel";
        if (saveResult === 'Marked Results') {
            results = selectedResults
        }
        else {
            results = JSON.parse(localStorage.getItem('displayedResults'))
        }
        if ((window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) {
            results.map((item, index) => {
                try {
                    csvData.push({
                        'Sl No': index + 1,
                        // 'Sl No': index + 1,
                        Authors: (item.detail.authors && item.detail.authors.length > 0) ? getVarType(item.detail.authors) === 'Array' ? item.detail.authors.join("; ") : item.detail.authors : "",
                        Owner: item.detail.owner === "Migration Specialist" ? "" : item.detail.owner,
                        Title: item.detail.docTitle,
                        'Link to Document': {
                            text: 'Link',
                            hyperlink: `${URLConstructor(item.detail)}`
                        },
                        'Document Type': item.detail.docType !== undefined && item.detail.docType.length > 0 ? item.detail.docType.join("; ") : "",
                        'Document Number': item.detail.documentNumber,
                        Product: item.detail.product !== undefined && item.detail.product.length > 0 ? item.detail.product.join("; ") : "",
                        'MSL Therapeutic Area': item.detail.mslTherapeuticArea !== undefined && item.detail.mslTherapeuticArea.length > 0 ? item.detail.mslTherapeuticArea : '',
                        Source: item.detail.domain,
                        Congress: item.detail.congressName !== undefined && item.detail.congressName.length > 0 ? item.detail.congressName.join("; ") : "",
                        'Protocol ID': item.detail.protocolIDs !== undefined && item.detail.protocolIDs.length > 0 ? item.detail.protocolIDs.join("; ") : "",
                        'Phase Of Study': item.detail.phaseOfStudy !== undefined && item.detail.phaseOfStudy.length > 0 ? item.detail.phaseOfStudy.join("; ") : "",
                        Language: item.detail.languages,
                        Country: item.detail.countries !== undefined && item.detail.countries.length > 0 ? item.detail.countries.join("; ") : "",
                        Version: item.detail.majorVersionNumber,
                        Date: item.detail.year,
                        'Last Updated': item.detail.lastUpdated !== undefined ? moment(item.detail.lastUpdated).format("D-MMM-YYYY") : "",
                        'Issued Date': item.detail.approvedDate !== undefined ? moment(item.detail.approvedDate).format("D-MMM-YYYY") : "",
                        'Modified Date': item.detail.modifiedDate !== undefined ? moment(item.detail.modifiedDate).format("D-MMM-YYYY") : "",
                        'PubMed ID': item.detail.pmID,
                        'Content Source': item.detail.csName,
                        'Key Takeaways': item.detail.keyTakeaways,
                        'Clinical Trial Name': item.detail.ctNames !== undefined && item.detail.ctNames.length > 0 ? item.detail.ctNames.join("; ") : "",
                    })
                } catch (error) {
                    console.log("error", error);
                }

                return null;
            })
            columns = [
                { header: "Sl No", key: "Sl No", width: 10 },
                { header: "Authors", key: "Authors", width: 36 },
                { header: "Owner", key: "Owner", width: 25 },
                { header: "Title", key: "Title", width: 36 },
                { header: "Link to Document", key: "Link to Document", width: 16 },
                { header: "Document Type", key: "Document Type", width: 15 },
                { header: "Document Number", key: "Document Number", width: 18 },
                { header: "Product", key: "Product", width: 33 },
                { header: "MSL Therapeutic Area", key: "MSL Therapeutic Area", width: 20 },
                { header: "Source", key: "Source", width: 10 },
                { header: "Congress", key: "Congress", width: 10 },
                { header: "Protocol ID", key: "Protocol ID", width: 10 },
                { header: "Phase Of Study", key: "Phase Of Study", width: 15 },
                { header: "Language", key: "Language", width: 10 },
                { header: "Country", key: "Country", width: 13 },
                { header: "Version", key: "Version", width: 10 },
                { header: "Date", key: "Date", width: 7 },
                { header: "Last Updated", key: "Last Updated", width: 12 },
                { header: "Issued Date", key: "Issued Date", width: 12 },
                { header: "Modified Date", key: "Modified Date", width: 12 },
                { header: "PubMed ID", key: "PubMed ID", width: 11 },
                { header: "Content Source", key: "Content Source", width: 25 },
                { header: "Key Takeaways", key: "Key Takeaways", width: 45 },
                { header: "Clinical Trial Name", key: "Clinical Trial Name", width: 20 },

            ];
            fileName = `iMS_Results_Download_${generateDownloadTimestamp()}.xlsx`;
            worksheetName = "iMS_Results_Excel";
        }
        else {
            results.map((item, index) => {
                try {
                    csvData.push({
                        'Sl No': index + 1,
                        Title: item.detail.title,
                        Authors: (item.detail.authors && item.detail.authors.length > 0) ? getVarType(item.detail.authors) === 'Array' ? item.detail.authors.join("; ") : item.detail.authors : "",
                        'Publication Date': item.detail.publicationDate,
                        Source: item.detail.source ? `${item.detail.source.name}.${item.detail.source.year};${item.detail.source.location}` : "",
                        'Protocol No.': (item.detail.protocolID && item.detail.protocolID.length > 0) ? item.detail.protocolID.join("; ") : "",
                        'PubMed ID': item.detail.PMID ? {
                            text: item.detail.PMID,
                            hyperlink: `https://pubmed.ncbi.nlm.nih.gov/${item.detail.PMID}/?otool=pajanslib`
                        } : '',
                        'DOI': item.detail.doi ? {
                            text: item.detail.doi,
                            hyperlink: `https://doi.org/${item.detail.doi}`
                        } : '',
                        'Language': (item.detail.language && item.detail.language !== 'eng') ? item.detail.languages : 'English',
                        'Content Source': 'PubMed',
                        'Substances': getVarType(item.detail.chemicals) !== 'Array' ? item.detail.chemicals : GenerateArrayStrings(item.detail.chemicals),
                        'MeSH Heading': getVarType(item.detail.meshHeading) !== 'Array' ? item.detail.meshHeading : GenerateArrayStrings(item.detail.meshHeading),
                        'Publication Type': getVarType(item.detail.publicationType) !== 'Array' ? item.detail.publicationType : GenerateArrayStrings(item.detail.publicationType),
                        'Link to Download': {
                            text: 'Link',
                            hyperlink: `${window.location.origin}/DocURLPubMed?sid=PMS&pmid=${item.detail.PMID}&ref=excel`
                        }
                    })
                } catch (error) {
                    console.log("error", error);
                }
                return null;
            })
            columns = [
                { header: "Sl No", key: "Sl No", width: 10 },
                { header: "Title", key: "Title", width: 25 },
                { header: "Authors", key: "Authors", width: 25 },
                { header: "Publication Date", key: "Publication Date", width: 25 },
                { header: "Source", key: "Source", width: 25 },
                { header: "Protocol No.", key: "Protocol No.", width: 25 },
                { header: "PubMed ID", key: "PubMed ID", width: 10 },
                { header: "DOI", key: "DOI", width: 25 },
                { header: "Language", key: "Language", width: 10 },
                { header: "Content Source", key: "Content Source", width: 15 },
                { header: "Substances", key: "Substances", width: 25 },
                { header: "MeSH Heading", key: "MeSH Heading", width: 25 },
                { header: "Publication Type", key: "Publication Type", width: 25 },
                { header: "Link to Download", key: "Link to Download", width: 18 }
            ];
            fileName = `PubMed_iMS_Results_Download_${generateDownloadTimestamp()}.xlsx`;
            worksheetName = "PubMed_iMS_Results_Excel";
        }

        setDocProcessing(true);
        let service = new ApiServices();
        await service.prepareExcelDocument(csvData, columns, worksheetName).then((res) => {
            const data = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            FileSaver.saveAs(data, fileName);
            setDocProcessing(false)
        }).catch((error) => {
            console.log(error);
            setDocProcessing(false)
        });
    }

    const URLConstructor = (item) => {
        let url = window.origin
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
            url += `/DocURL?ID=${item.docID}&ref=excel&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            // url += `/DocURL?ID=${item.docTitle}&ref=excel&cs=${item.domain}`
        }
        else if (item.domain === 'SKM' || item.domain === 'IROs' || item.domain === "MIAs") {
            url += `/DocURL?ID=${item.docID}&ref=excel&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else {
            url += `/DocURL?ID=${item.docID}&ref=excel&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                url = url + `&docState=anr`
            }
        }
        return url
    }
    const handleEmail = (searchId) => {
        // let url = 
        // // url = URLConstructor(item,'email')
        // indexdata(item,url,appliedFilters,searchKeyword,pageNumber,pageSize,'Email')
        let downloadurl = `/iMS_Emails?id=${searchId}`
        let mailUrl = window.location.origin + downloadurl
        // let kmUrl = 'http://teamsna.jnj.com/jom/omjsasystemssupport/omjsasupport/Lists/Service%20Center%20202010/NewForm.aspx';
        // kmUrl = encodeURIComponent(kmUrl);
        // if(item.docTitle.includes('&')){
        //    title=item.docTitle.replaceAll('&','%26')
        // }
        let mailbody = (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? `${mailUrl}%0D%0DNote:-This url is valid for 60 days.%0D%0DFor access to iMedical Search, please log onto ${window.location.origin}` : `${mailUrl}%0D%0DNote:-This url is valid for 60 days.`;
        let mailSubject = (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? " Search Results from iMedical Search" : "PubMed Search Results from iMedical Search";
        window.open(`mailto:?Subject=${mailSubject}&body=${mailbody}`)
        // window.open(`mailto:?Subject=Search results from iMedical Search&body=${mailbody}`)
    }
    const handelEmailDocsTypes = (searchId) => {
        let downloadurl = `/iMS_Emails?id=${searchId}`
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem('companyname'),
            (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? 'Email List' : 'Email PubMed List',
            window.location.origin + downloadurl,
            window.location.href,
            props.querytext,
            props.appliedFilters
        );
    }
    const handelSaveExportDocsTypes = (formate) => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem('companyname'),
            (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? `Save Document - ${formate}` : `Save PubMed Document - ${formate}`,
            "",
            window.location.href,
            props.querytext,
            props.appliedFilters
        );
    }
    const handelDownloadDocs = (filename) => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem('companyname'),
            `Download Document - ${filename}`,
            "",
            window.location.href,
            props.querytext,
            props.appliedFilters
        );
    }
    const handelDownloadAllDocs = () => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem('companyname'),
            `Download All Document`,
            "",
            window.location.href,
            props.querytext,
            props.appliedFilters
        );
    }
    const handelPrintDocs = () => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem('companyname'),
            (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') ? `Print Document` : `Print PubMed Document`,
            "",
            window.location.href,
            props.querytext,
            props.appliedFilters
        );
    }
    if (customWidth < 600) {
        return (
            <Modal
                show={showPop}
                size="lg md sm xs"
                centered
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="popup-transition-mob-tab"
                scrollable={true}
            >
                <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                    {/* <div className="popup-cancel-btn-wrapper">
                            <img src={popCancelBttn} alt="" onClick={(e) => { setShow(false); handleClose(false) }} />
                        </div> */}
                    <div /* style={{ padding: "0 5%" }} */>
                        <Modal.Header className="gsfModalHeader" style={{ justifyContent: "center" }}>
                            <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                <Modal.Title>
                                    <div className="actionItem-headerPart">
                                        {/* <div onClick={onSaveClick} className={isSaveModal ? "active-features-button" : "features-buttons"}>
                                                <img src={isSaveModal ? saveWhiteIcon : saveBlueIcon} alt="save-icon" width={17} height={17} className="vs-img" />
                                                <img src={saveWhiteIcon} alt="save-icon" width={17} height={17} className="vs-img-hov" />
                                                <span>Save</span>
                                            </div>
                                            <div className="action-button-saperation-line"></div>
                                            <div onClick={onPrintClick} className={isPrintModal ? "active-features-button" : "features-buttons"}>
                                                <img src={isPrintModal ? printWhiteIcon : printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                                                <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                                                <span>Print</span>
                                            </div>
                                            <div className="action-button-saperation-line"></div> */}
                                        {/* <div onClick={onEmailClick} className={isEmailModal ? "active-features-button" : "features-buttons"}> */}
                                        <div className="active-features-button-mobile">
                                            <img src={isEmailModal ? emailWhiteIcon : emailBlueIcon} alt="email-icon" width={20} height={20} className="vs-img" />
                                            <img src={emailWhiteIcon} alt="save-icon" width={20} height={20} className="vs-img-hov" />
                                            <span>Email</span>
                                        </div>
                                        {/* <div className="action-button-saperation-line"></div>
                                            <div onClick={onDownloadClick} className={isDownloadModal ? "active-features-button" : "features-buttons"}>
                                                <img src={isDownloadModal ? downloadWhiteIcon : downloadBlueIcon} alt="download-icon" width={18} height={18} className="vs-img" />
                                                <img src={downloadWhiteIcon} alt="save-icon" width={18} height={18} className="vs-img-hov" />
                                                <span>Download</span>
                                            </div> */}
                                    </div>
                                </Modal.Title>
                            </div>
                        </Modal.Header>
                        <Modal.Body scrollable={true} style={{ height: height }}>
                            <div>
                                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <><span className="cs-modalNote">PLEASE NOTE: iMedicalSearch content is for internal use ONLY, not to be shared externally. See the <a className="gsf-dsclmr-link" onClick={(e) => { setDisclaimer(true) }}>full disclaimer</a>.</span>
                                    <br />
                                    <br /></>}
                                {
                                    isEmailModal &&
                                    <div className="email-popup-inputContainer-mobile">
                                        <div>
                                            <span className="gsf-popup-inputHeading">Results To Email :</span><br />
                                            <div className="gsf-popup-inputContainer-mobile">
                                                <div className="gsf-popup-inputPart-mobile">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangeEmailResult} checked={emailResult === 'Marked Results'} style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                                    <label style={{ color: emailResult === 'Marked Results' ? "#333" : "#63666A" }}>Marked Results</label>
                                                </div>
                                                <div className="gsf-popup-inputPart-mobile">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangeEmailResult} checked={emailResult === 'Displayed Results'} />
                                                    <label style={{ color: emailResult === 'Displayed Results' ? "#333" : "#63666A" }}>Displayed Results</label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="partition-line" />
                                        <div>
                                            <span className="gsf-popup-inputHeading">Fields To Include :</span><br />
                                            <div className="gsf-popup-inputContainer-mobile">
                                                <div className="gsf-popup-inputPart-mobile">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="titleOnly" value="Title Only" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Title Only'} />
                                                    <label style={{ color: emailFields === 'Title Only' ? "#333" : "#63666A" }}>Title Only</label>
                                                </div>
                                                <div className="gsf-popup-inputPart-mobile">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="fullCitation" value="Full Citation" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Full Citation'} />
                                                    <label style={{ color: emailFields === 'Full Citation' ? "#333" : "#63666A" }}>Full Citation</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </Modal.Body>
                        <div className="gsf-popup-button-wrapper-mobile">
                            <div className="welcomeNxtBtn-mobile">
                                <MobileViewButton text="Proceed" customColor="#EB1700" action={onClickProceed} />

                            </div>
                            <div className="welcomeNxtBtn-mobile">
                                <MobileViewButton text="Cancel" customColor="#000000" action={() => { setShow(false); handleClose(false) }} />
                            </div>
                        </div>
                    </div>
                </div>
                {showDisclaimer &&
                    <>
                        <DisclaimerPop display={showDisclaimer} handleClose={(status) => { setDisclaimer(status) }} />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {emailProcessing &&
                    <>
                        <EmailProcessingPopUpModal showModal={emailProcessing} color="#0074B0" />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => closeAlertMessage()} />}
            </Modal>
        )
    }
    else if (customWidth < 1000) {
        return (
            <Modal
                show={showPop}
                size="lg md sm xs"
                centered
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="popup-transition-mob-tab"
                scrollable={true}
            >
                <div style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}>
                    {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e) => { setShow(false); handleClose(false) }} />
                    </div> */}
                    <div /* style={{ padding: "0 5%" }} */>
                        <Modal.Header className="gsfModalHeader" style={{ justifyContent: "center" }}>
                            <div style={{ textAlign: "center", width: "100%", paddingTop: "1%" }}>
                                <Modal.Title>
                                    <div className="actionItem-headerPart">
                                        {/* <div onClick={onSaveClick} className={isSaveModal ? "active-features-button" : "features-buttons"}>
                                            <img src={isSaveModal ? saveWhiteIcon : saveBlueIcon} alt="save-icon" width={17} height={17} className="vs-img" />
                                            <img src={saveWhiteIcon} alt="save-icon" width={17} height={17} className="vs-img-hov" />
                                            <span>Save</span>
                                        </div>
                                        <div className="action-button-saperation-line"></div>
                                        <div onClick={onPrintClick} className={isPrintModal ? "active-features-button" : "features-buttons"}>
                                            <img src={isPrintModal ? printWhiteIcon : printBlueIcon} alt="print-icon" width={15} height={15} className="vs-img" />
                                            <img src={printWhiteIcon} alt="save-icon" width={15} height={15} className="vs-img-hov" />
                                            <span>Print</span>
                                        </div>
                                        <div className="action-button-saperation-line"></div> */}
                                        {/* <div onClick={onEmailClick} className={isEmailModal ? "active-features-button" : "features-buttons"}> */}
                                        <div className="active-features-button-tablet">
                                            <img src={isEmailModal ? emailWhiteIcon : emailBlueIcon} alt="email-icon" width={20} height={20} className="vs-img" />
                                            <img src={emailWhiteIcon} alt="save-icon" width={20} height={20} className="vs-img-hov" />
                                            <span>Email</span>
                                        </div>
                                        {/* <div className="action-button-saperation-line"></div>
                                        <div onClick={onDownloadClick} className={isDownloadModal ? "active-features-button" : "features-buttons"}>
                                            <img src={isDownloadModal ? downloadWhiteIcon : downloadBlueIcon} alt="download-icon" width={18} height={18} className="vs-img" />
                                            <img src={downloadWhiteIcon} alt="save-icon" width={18} height={18} className="vs-img-hov" />
                                            <span>Download</span>
                                        </div> */}
                                    </div>
                                </Modal.Title>
                            </div>
                        </Modal.Header>
                        <Modal.Body scrollable={true} style={{ height: height }}>
                            <div>
                                {(window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList') && <><span className="cs-modalNote">PLEASE NOTE: iMedicalSearch content is for internal use ONLY, not to be shared externally. See the <a className="gsf-dsclmr-link" onClick={(e) => { setDisclaimer(true) }}>full disclaimer</a>.</span>
                                    <br />
                                    <br /></>}
                                {
                                    isEmailModal &&
                                    <div>
                                        <div>
                                            <span className="gsf-popup-inputHeading">Results To Email :</span><br />
                                            <div className="gsf-popup-inputContainer" style={{ width: "50%", marginBottom: "10px" }}>
                                                <div className="gsf-popup-inputPart">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangeEmailResult} checked={emailResult === 'Marked Results'} style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                                    <label style={{ color: emailResult === 'Marked Results' ? "#333" : "#63666A" }}>Marked Results</label>
                                                </div>
                                                <div className="gsf-popup-inputPart">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangeEmailResult} checked={emailResult === 'Displayed Results'} />
                                                    <label style={{ color: emailResult === 'Displayed Results' ? "#333" : "#63666A" }}>Displayed Results</label>
                                                </div>
                                            </div>
                                        </div>
                                        <hr className="partition-line" />
                                        <div>
                                            <span className="gsf-popup-inputHeading">Fields To Include :</span><br />
                                            <div className="gsf-popup-inputContainer" style={{ width: "45.5%" }}>
                                                <div className="gsf-popup-inputPart">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="titleOnly" value="Title Only" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Title Only'} />
                                                    <label style={{ color: emailFields === 'Title Only' ? "#333" : "#63666A" }}>Title Only</label>
                                                </div>
                                                <div className="gsf-popup-inputPart">
                                                    <input type="radio" className="gsf-popup-radioInput k-radio" name="fullCitation" value="Full Citation" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Full Citation'} />
                                                    <label style={{ color: emailFields === 'Full Citation' ? "#333" : "#63666A" }}>Full Citation</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </Modal.Body>
                        <div className="gsf-popup-button-wrapper-tablet">
                            <div className="welcomeNxtBtn">
                                <Button text="Cancel" customColor="#000000" action={() => { setShow(false); handleClose(false) }} />
                            </div>
                            <div className="welcomeNxtBtn">
                                <Button text="Proceed" customColor="#EB1700" action={onClickProceed} />
                            </div>
                        </div>
                    </div>
                </div>
                {showDisclaimer &&
                    <>
                        <DisclaimerPop display={showDisclaimer} handleClose={(status) => { setDisclaimer(status) }} />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {emailProcessing &&
                    <>
                        <EmailProcessingPopUpModal showModal={emailProcessing} color="#0074B0" />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => closeAlertMessage()} />}
            </Modal>
        )
    }
    else {
        return (
            <Modal
                show={showPop}
                size="lg md sm xs"
                centered
                aria-labelledby="contained-modal-title-vcenter"
                dialogClassName="popup-transition"
                scrollable={true}
            >
                <div className="gen-ai-gsf-popup">
                    {/* pdfHtml && */
                        <div id="pdf-doc-to-print" style={{ display: "none", width: "100%" }}>
                            <div className="bannerImage">
                                <div className="headerTitle" style={{ alignItems: "center", textAlign: "center" }}>
                                    <img src={IMSLogo} alt="iMedical Search" style={{ width: "20%", paddingTop: "2%" }} />
                                </div>
                            </div>
                            <PDFCitationdetailsGenAI selectedResults={selectedResults} citationType={saveResult} titleOnly={saveFields} />
                        </div>
                    }
                    <div /* style={{ padding: "0 5%" }} */>
                        {/* <Modal.Header> */}
                        <div className="gen-ai-gsf-popup__header">
                            <div className="gen-ai-gsf-popup__tabs">
                                <button onClick={onSaveClick} className={`gen-ai-gsf-popup__tab ${isSaveModal ? "gen-ai-gsf-popup__tab--active" : ""}`}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4.66667 2H9.78301C10.1091 2 10.2722 2 10.4256 2.03684C10.5617 2.0695 10.6918 2.12337 10.811 2.19648C10.9456 2.27894 11.0609 2.39424 11.2915 2.62484L13.3752 4.7085C13.6058 4.9391 13.7211 5.0544 13.8035 5.18895C13.8766 5.30825 13.9305 5.43831 13.9632 5.57436C14 5.72781 14 5.89087 14 6.21699V11.3333M8.33333 6.66667H5.73333C5.35997 6.66667 5.17328 6.66667 5.03067 6.594C4.90523 6.53009 4.80324 6.4281 4.73933 6.30266C4.66667 6.16005 4.66667 5.97337 4.66667 5.6V4.33333M9 14V11.0667C9 10.6933 9 10.5066 8.92734 10.364C8.86342 10.2386 8.76144 10.1366 8.63599 10.0727C8.49339 10 8.3067 10 7.93333 10H5.73333C5.35997 10 5.17328 10 5.03067 10.0727C4.90523 10.1366 4.80324 10.2386 4.73933 10.364C4.66667 10.5066 4.66667 10.6933 4.66667 11.0667V14M11.6667 6.77516V11.8667C11.6667 12.6134 11.6667 12.9868 11.5213 13.272C11.3935 13.5229 11.1895 13.7268 10.9387 13.8547C10.6534 14 10.2801 14 9.53333 14H4.13333C3.3866 14 3.01323 14 2.72801 13.8547C2.47713 13.7268 2.27316 13.5229 2.14532 13.272C2 12.9868 2 12.6134 2 11.8667V6.46667C2 5.71993 2 5.34656 2.14532 5.06135C2.27316 4.81046 2.47713 4.60649 2.72801 4.47866C3.01323 4.33333 3.3866 4.33333 4.13333 4.33333H9.22484C9.3879 4.33333 9.46943 4.33333 9.54615 4.35175C9.61418 4.36808 9.67921 4.39502 9.73886 4.43157C9.80613 4.4728 9.86379 4.53045 9.97909 4.64575L11.3542 6.02091C11.4695 6.13622 11.5272 6.19387 11.5684 6.26114C11.605 6.32079 11.6319 6.38582 11.6482 6.45385C11.6667 6.53057 11.6667 6.6121 11.6667 6.77516Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span className="gen-ai-gsf-popup__tab-label">Save</span>
                                </button>
                                {/* <button onClick={onPrintClick} className={`gen-ai-gsf-popup__tab ${isPrintModal ? "gen-ai-gsf-popup__tab--active" : ""}`}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1478_934)">
                                            <path d="M12.0002 4.66683V3.46683C12.0002 2.72009 12.0002 2.34672 11.8548 2.06151C11.727 1.81063 11.523 1.60665 11.2721 1.47882C10.9869 1.3335 10.6136 1.3335 9.86683 1.3335H6.1335C5.38676 1.3335 5.01339 1.3335 4.72818 1.47882C4.47729 1.60665 4.27332 1.81063 4.14549 2.06151C4.00016 2.34672 4.00016 2.72009 4.00016 3.46683V4.66683M4.00016 12.0002C3.38018 12.0002 3.07019 12.0002 2.81586 11.932C2.12567 11.7471 1.58658 11.208 1.40164 10.5178C1.3335 10.2635 1.3335 9.95348 1.3335 9.3335V7.86683C1.3335 6.74672 1.3335 6.18667 1.55148 5.75885C1.74323 5.38252 2.04919 5.07656 2.42552 4.88482C2.85334 4.66683 3.41339 4.66683 4.5335 4.66683H11.4668C12.5869 4.66683 13.147 4.66683 13.5748 4.88482C13.9511 5.07656 14.2571 5.38252 14.4488 5.75885C14.6668 6.18667 14.6668 6.74672 14.6668 7.86683V9.3335C14.6668 9.95348 14.6668 10.2635 14.5987 10.5178C14.4137 11.208 13.8747 11.7471 13.1845 11.932C12.9301 12.0002 12.6201 12.0002 12.0002 12.0002M10.0002 7.00016H12.0002M6.1335 14.6668H9.86683C10.6136 14.6668 10.9869 14.6668 11.2722 14.5215C11.523 14.3937 11.727 14.1897 11.8548 13.9388C12.0002 13.6536 12.0002 13.2802 12.0002 12.5335V11.4668C12.0002 10.7201 12.0002 10.3467 11.8548 10.0615C11.727 9.81063 11.523 9.60665 11.2722 9.47882C10.9869 9.3335 10.6136 9.3335 9.86683 9.3335H6.1335C5.38676 9.3335 5.01339 9.3335 4.72818 9.47882C4.47729 9.60665 4.27332 9.81063 4.14549 10.0615C4.00016 10.3467 4.00016 10.7201 4.00016 11.4668V12.5335C4.00016 13.2802 4.00016 13.6536 4.14549 13.9388C4.27332 14.1897 4.47729 14.3937 4.72818 14.5215C5.01339 14.6668 5.38676 14.6668 6.1335 14.6668Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1478_934">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="gen-ai-gsf-popup__tab-label">Print</span>
                                </button> */}
                                <button onClick={onEmailClick} className={`gen-ai-gsf-popup__tab ${isEmailModal ? "gen-ai-gsf-popup__tab--active" : ""}`}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_1478_1204)">
                                            <path d="M1.3335 4.6665L6.77678 8.4768C7.21756 8.78535 7.43795 8.93962 7.67767 8.99938C7.88943 9.05216 8.1109 9.05216 8.32265 8.99938C8.56238 8.93962 8.78277 8.78535 9.22355 8.4768L14.6668 4.6665M4.5335 13.3332H11.4668C12.5869 13.3332 13.147 13.3332 13.5748 13.1152C13.9511 12.9234 14.2571 12.6175 14.4488 12.2412C14.6668 11.8133 14.6668 11.2533 14.6668 10.1332V5.8665C14.6668 4.7464 14.6668 4.18635 14.4488 3.75852C14.2571 3.3822 13.9511 3.07624 13.5748 2.88449C13.147 2.6665 12.5869 2.6665 11.4668 2.6665H4.5335C3.41339 2.6665 2.85334 2.6665 2.42552 2.88449C2.04919 3.07624 1.74323 3.3822 1.55148 3.75852C1.3335 4.18635 1.3335 4.7464 1.3335 5.8665V10.1332C1.3335 11.2533 1.3335 11.8133 1.55148 12.2412C1.74323 12.6175 2.04919 12.9234 2.42552 13.1152C2.85334 13.3332 3.41339 13.3332 4.5335 13.3332Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_1478_1204">
                                                <rect width="16" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span className="gen-ai-gsf-popup__tab-label">Email</span>
                                </button>
                                <button onClick={onDownloadClick} className={`gen-ai-gsf-popup__tab ${isDownloadModal ? "gen-ai-gsf-popup__tab--active" : ""}`}>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 10V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V10M11.3333 6.66667L8 10M8 10L4.66667 6.66667M8 10V2" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span className="gen-ai-gsf-popup__tab-label">Download</span>
                                </button>
                            </div>

                            <div className="gen-ai-gsf-popup__icon-placeholder" onClick={(e) => { setShow(false); handleClose(false) }} aria-hidden>
                                <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18 6L6 18M6 6L18 18" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                            </div>
                        </div>
                        {/* </Modal.Header> */}
                        <div className="gen-ai-gsf-popup__body" style={isDownloadProceed ? { maxHeight: "44vh", overflowY: "auto" } : {}} role="dialog" aria-label="Save / Export options">
                            {(!isDownloadProceed && (window.location.pathname !== '/pubMedResults' && window.location.pathname !== '/viewPubMedReadingList')) &&
                                <>
                                    <div className="gen-ai-gsf-popup__notice">
                                        <span className="gen-ai-gsf-popup__notice-text">
                                            PLEASE NOTE: iMedicalSearch content is for internal use ONLY, not to be shared externally. See the <a className="gsf-dsclmr-link" onClick={(e) => { setDisclaimer(true) }}>full disclaimer</a>.
                                        </span>
                                    </div>
                                </>
                            }
                            {
                                isSaveModal && <>
                                    <div className="gen-ai-gsf-popup__section">
                                        <h3 className="gen-ai-gsf-popup__section-title">Results To Save:</h3>

                                        <div className="gen-ai-gsf-popup__options-row">
                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangeSaveResult} checked={saveResult === 'Marked Results'} /* disabled={selectedResults.length<=0} */ style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                                <span>Marked Results</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangeSaveResult} checked={saveResult === 'Displayed Results'} />
                                                <span>Displayed Results</span>
                                            </label>
                                        </div>
                                        {
                                            (window.location.pathname !== '/viewmarked' && window.location.pathname !== '/old_viewmarked' && window.location.pathname !== '/GenAIViewmarked') ?
                                                <div className="gen-ai-gsf-popup__hint">
                                                    ({itemsPerPage} items currently displayed) <span onClick={() => { setShow(false); handleClose(false) }} className="saveModalHyperlink"> Click here to change 'Items per page'</span>, then re-click on the 'Save/Export' icon.
                                                </div> :
                                                <div className="gen-ai-gsf-popup__hint">
                                                    Please select 'Items per page' to save/export data.
                                                </div>
                                        }
                                    </div>

                                    <div className="gen-ai-gsf-popup__divider" />

                                    <div className="gen-ai-gsf-popup__section">
                                        <h3 className="gen-ai-gsf-popup__section-title">Fields To Include:</h3>

                                        <div className="gen-ai-gsf-popup__options-row">
                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="titleOnly" value="Title Only" onChange={saveFormat === 'Excel' ? null : handleOnChangeSaveFieldstoInclude} checked={saveFields === 'Title Only'} style={{ cursor: saveFormat === 'Excel' ? "no-drop" : null }} />
                                                <span>Title Only</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="fullCitation" value="Full Citation" onChange={saveFormat === 'Excel' ? null : handleOnChangeSaveFieldstoInclude} checked={saveFields === 'Full Citation'} style={{ cursor: saveFormat === 'Excel' ? "no-drop" : null }} />
                                                <span>Full Citation</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="gen-ai-gsf-popup__divider" />
                                    <div className="gen-ai-gsf-popup__section">
                                        <h3 className="gen-ai-gsf-popup__section-title">Format:</h3>

                                        <div className="gen-ai-gsf-popup__options-row">
                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="formatExcel" value="Excel" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'Excel'} />
                                                <span>Excel</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="formatpdf" value="Pdf" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'Pdf'} />
                                                <span>Pdf</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="formathtml" value="HTML" onChange={handleOnChangeSaveFormat} checked={saveFormat === 'HTML'} />
                                                <span>HTML</span>
                                            </label>
                                        </div>
                                    </div></>}
                            {
                                isPrintModal && <>
                                    <div className="gen-ai-gsf-popup__section">
                                        <h3 className="gen-ai-gsf-popup__section-title">Results To Print:</h3>

                                        <div className="gen-ai-gsf-popup__options-row">
                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangePrintResult} checked={printResult === 'Marked Results'} style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                                <span>Marked Results</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangePrintResult} checked={printResult === 'Displayed Results'} />
                                                <span>Displayed Results</span>
                                            </label>
                                        </div>
                                    </div>

                                    <div className="gen-ai-gsf-popup__divider" />

                                    <div className="gen-ai-gsf-popup__section">
                                        <h3 className="gen-ai-gsf-popup__section-title">Fields To Include:</h3>

                                        <div className="gen-ai-gsf-popup__options-row">
                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="titleOnly" value="Title Only" onChange={handleOnChangePrintFieldstoInclude} checked={printFields === 'Title Only'} />
                                                <span>Title Only</span>
                                            </label>

                                            <label className="gen-ai-gsf-popup__checkbox">
                                                <input type="radio" name="fullCitation" value="Full Citation" onChange={handleOnChangePrintFieldstoInclude} checked={printFields === 'Full Citation'} />
                                                <span>Full Citation</span>
                                            </label>
                                        </div>
                                    </div>
                                    {isPrintProceed && <div
                                        style={{ display: "none" }}// This make ComponentToPrint show   only while printing
                                    >
                                        <HtmlView ref={componentRef} selectedResults={selectedResults} titleOnly={titleOnlyPrint} citationType={printResult} />
                                    </div>}

                                </>}
                            {isEmailModal && <>
                                <div className="gen-ai-gsf-popup__section">
                                    <h3 className="gen-ai-gsf-popup__section-title">Results To Email:</h3>

                                    <div className="gen-ai-gsf-popup__options-row">
                                        <label className="gen-ai-gsf-popup__checkbox">
                                            <input type="radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangeEmailResult} checked={emailResult === 'Marked Results'} style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                            <span>Marked Results</span>
                                        </label>

                                        <label className="gen-ai-gsf-popup__checkbox">
                                            <input type="radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangeEmailResult} checked={emailResult === 'Displayed Results'} />
                                            <span>Displayed Results</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="gen-ai-gsf-popup__divider" />

                                <div className="gen-ai-gsf-popup__section">
                                    <h3 className="gen-ai-gsf-popup__section-title">Fields To Include:</h3>

                                    <div className="gen-ai-gsf-popup__options-row">
                                        <label className="gen-ai-gsf-popup__checkbox">
                                            <input type="radio" name="titleOnly" value="Title Only" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Title Only'} />
                                            <span>Title Only</span>
                                        </label>

                                        <label className="gen-ai-gsf-popup__checkbox">
                                            <input type="radio" name="fullCitation" value="Full Citation" onChange={handleOnChangeEmailFieldstoInclude} checked={emailFields === 'Full Citation'} />
                                            <span>Full Citation</span>
                                        </label>
                                    </div>
                                </div>
                            </>}
                            {
                                isDownloadModal && <>
                                    <div className="gen-ai-gsf-popup__section">
                                        <div className="gen-ai-gsf-popup__row gen-ai-gsf-popup__row--spaced">
                                            <div className="gen-ai-gsf-popup__label">File Marked:</div>
                                            <div className="gen-ai-gsf-popup__value">{selectedResults.length}</div>
                                        </div>

                                    </div>
                                    {isDownloadProceed ? <div className="gen-ai-gsf-popup__section">
                                        <div className="gen-ai-gsf-popup__row gen-ai-gsf-popup__row--spaced gen-ai-gsf-popup__row--download">
                                            <div className="gen-ai-gsf-popup__label">File Name: </div>
                                            <div className="gen-ai-gsf-popup__value">
                                                {proceedDownload(downloadData)}
                                            </div>
                                            <div className="gen-ai-gsf-popup__link" onClick={downloadAll}>Download All</div>
                                        </div>

                                    </div>
                                        :
                                        <div className="gen-ai-gsf-popup__section">
                                            <h3 className="gen-ai-gsf-popup__section-title">Results To Download:</h3>

                                            <div className="gen-ai-gsf-popup__options-row">
                                                <label className="gen-ai-gsf-popup__checkbox">
                                                    <input type="radio" name="markedResults" value="Marked Results" onChange={selectedResults.length <= 0 ? null : handleOnChangeDownloadResult} checked={downloadResult === 'Marked Results'} style={{ cursor: selectedResults.length <= 0 ? "no-drop" : "pointer" }} />
                                                    <span>Marked Results</span>
                                                </label>

                                                <label className="gen-ai-gsf-popup__checkbox">
                                                    <input type="radio" name="displayedResults" value="Displayed Results" onChange={handleOnChangeDownloadResult} checked={downloadResult === 'Displayed Results'} />
                                                    <span>Displayed Results</span>
                                                </label>
                                            </div>
                                        </div>
                                    }
                                </>}
                        </div>
                        {/* <Modal.Body scrollable={true} style={{ height: height }}> */}

                        {/* </Modal.Body> */}
                        {
                            isDownloadProceed ?
                                <div className="gen-ai-gsf-popup__footer">
                                    <button
                                        type="button"
                                        className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--outline"
                                        onClick={() => { setShow(false); handleClose(false) }}
                                    >
                                        Cancel
                                    </button>
                                </div>
                                :
                                <div className="gen-ai-gsf-popup__footer">
                                    <button
                                        type="button"
                                        className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--outline"
                                        onClick={() => { setShow(false); handleClose(false) }}
                                    >
                                        Cancel
                                    </button>

                                    <button
                                        type="button"
                                        className="gen-ai-gsf-popup__btn gen-ai-gsf-popup__btn--primary"
                                        onClick={onClickProceed}
                                    >
                                        Proceed
                                    </button>
                                </div>
                        }

                    </div>
                </div>
                {showDisclaimer &&
                    <>
                        <DisclaimerPop display={showDisclaimer} handleClose={(status) => { setDisclaimer(status) }} />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {showSaveToExcel && /* console.log(selectedResults), */
                    <>
                        <GenAIGSFSaveSubModal showModal={showSaveToExcel} handleClose={(status) => { setSaveToExcel(status) }} color="#0074B0" onViewClick={onViewClick} selectedResults={selectedResults} onClickDownload={onClickDownloadExcel} />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {docProcessing &&
                    <>
                        <DocumentProcessing showModal={docProcessing} color="#EB1700" />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {emailProcessing &&
                    <>
                        <EmailProcessingPopUpModal showModal={emailProcessing} color="#EB1700" />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {downloadZipProcessing &&
                    <>
                        <DownloadProcessingPopUpModal showModal={downloadZipProcessing} color="#EB1700" />
                        <div className="savemodal-outer-wrapper"></div>
                    </>
                }
                {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => closeAlertMessage()} />}
            </Modal>
        )
    }
}